import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "radioTune"
const RadioTuneIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.375 10.5C17.653 10.5 19.5 12.347 19.5 14.625S17.653 18.75 15.375 18.75 11.25 16.903 11.25 14.625 13.097 10.5 15.375 10.5M15.375 12C13.925 12 12.75 13.175 12.75 14.625S13.925 17.25 15.375 17.25 18 16.074 18 14.625 16.825 12 15.375 12"
            clipRule="evenodd"
          />
          <path d="M9 14.25C9 15.078 8.328 15.75 7.5 15.75H4.5V14.25zM9 11.25C9 12.078 8.328 12.75 7.5 12.75H4.5V11.25z" />
          <path
            fillRule="evenodd"
            d="M17.695 1.564C18.074 1.396 18.517 1.567 18.685 1.945S18.684 2.767 18.306 2.935L8.035 7.5H21C21.828 7.5 22.5 8.17 22.5 9V20.25C22.5 21.078 21.828 21.75 21 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V9C1.5 8.17 2.172 7.5 3 7.5H4.34zM3 20.25H21V9H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RadioTuneIcon
